import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, Observable, of, tap } from 'rxjs';

import { config } from '@/config';

export type TicketNotificationsRole = 'agent' | 'employee';

export interface TicketNotificationItem {
  id: number;
  code: string;
  subject: string;
  updatedAt: string;
}

export interface TicketNotificationsPayload {
  role: TicketNotificationsRole;
  count: number;
  items: TicketNotificationItem[];
}

@Injectable({ providedIn: 'root' })
export class TicketNotificationsService {
  private dataSubject = new BehaviorSubject<TicketNotificationsPayload | null>(null);
  data$ = this.dataSubject.asObservable();

  private acknowledgedTickets = new Map<number, string>();

  constructor(private http: HttpClient) {}

  // refresh(): Observable<TicketNotificationsPayload | null> {
  //   return this.http.get<TicketNotificationsPayload>(`${config.apiUrl}/ticketing/tickets/notifications`).pipe(
  //     tap((payload) => this.dataSubject.next(this.applyAcknowledgements(payload))),
  //     catchError(() => {
  //       this.dataSubject.next(null);
  //       return of(null);
  //     }),
  //   );
  // }

  acknowledgeTicket(ticketId: number, updatedAt?: string | null) {
    const payload = this.dataSubject.getValue();
    const timestamp = updatedAt ?? payload?.items.find((item) => item.id === ticketId)?.updatedAt;
    if (!payload || !timestamp) return;

    this.acknowledgedTickets.set(ticketId, timestamp);
    this.dataSubject.next(this.applyAcknowledgements(payload));
  }

  private applyAcknowledgements(payload: TicketNotificationsPayload): TicketNotificationsPayload {
    const items: TicketNotificationItem[] = [];
    for (const item of payload.items) {
      const ackTimestamp = this.acknowledgedTickets.get(item.id);
      if (ackTimestamp) {
        if (ackTimestamp === item.updatedAt) {
          continue;
        }
        this.acknowledgedTickets.delete(item.id);
      }
      items.push(item);
    }
    return { ...payload, count: items.length, items };
  }
}
